import React, { createContext, useContext, useState } from 'react';

const MuteContext = createContext();

export const useMute = () => useContext(MuteContext);

export const MuteProvider = ({ children }) => {
  const [volume, setVolume] = useState(0);
  const [version, setVersion] = useState(0);
  const [activeVideoId, setActiveVideoId] = useState(null);

  const toggleMute = () => {
    setVolume(prev => prev === 0 ? 0.5 : 0);
    setVersion(v => v + 1);
  };

  return (
    <MuteContext.Provider value={{
      volume, toggleMute, version,
      activeVideoId, setActiveVideoId
    }}>
      {children}
    </MuteContext.Provider>
  );
};
